export default {
  /**
   * @param state
   * @returns {[]}
   */
  getAddons(state) {
    const addons = [];
    state.addons.items.forEach((addon) => {
      addons.push({ ...addon });
    });
    return addons.filter((addon) => {
      if (!state.addons.search) {
        return true;
      }
      const searchIn = addon.description;
      return searchIn.toLowerCase()
        .indexOf(state.addons.search.toLowerCase()) !== -1;
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/restech/getters.js